const $languageSwitch = $('.js-language-switch');
const $initiallyChosenLanguage = $languageSwitch.find('.language-switch__language.active a');
const $languageOptionsHolder = $languageSwitch.find('.language-switch__options-holder');
const $chosenLanguageButton = $languageSwitch.find('button');
const $languageSwitchDesktop = $('.js-language-switch-desktop');
const $chosenLanguageButtonDesktop = $languageSwitchDesktop.find('button');
const $tooltip = $languageSwitchDesktop.find('.language-switch__tooltip');
const $tooltipMarker = $tooltip.find('.language-switch__tooltip__marker');

export function initLanguageSwitch() {
  let languageContent = $initiallyChosenLanguage.html();
  $chosenLanguageButton.append(languageContent);
  $initiallyChosenLanguage.attr('tabindex', '-1');

  initTooltip();
  initCollapse();
  initOffCanvas();
}

function initCollapse() {
  $chosenLanguageButton.on('click', (e) => {
    const $button = $(e.target);
    $button.toggleClass('open');

    setTimeout(() => {
      if ($button.hasClass('open')) {
        const $notActiveLanguages = $languageSwitch.find('.language-switch__language:not(.active) a');
        $notActiveLanguages.first().focus();
      }
    }, 50);

    $languageOptionsHolder.toggleClass('d-none');
  })
}

function initTooltip() {
  calculateMarker();

  $languageSwitchDesktop.on('click', () => {
    toggleLanguageSwitchDesktop();
  })
  // Necessary because $languageSwitchDesktop is not a button
  $languageSwitchDesktop.on('keypress', (e) => {
    const key = e.which;
    if (key === 13) {
      toggleLanguageSwitchDesktop();
    }
  })
}

function toggleLanguageSwitchDesktop() {
  $tooltip.removeClass('d-none');
  setTimeout(() => {
    $chosenLanguageButtonDesktop.focus();
    $tooltip.on('focusout', (e) => {
      if(!e.currentTarget.contains(e.relatedTarget)) {
        $tooltip.addClass('d-none');
      }
    })
  }, 50);
}

function calculateMarker() {
  const buttonWidth = $languageSwitchDesktop.width();
  const iconWidth = $languageSwitchDesktop.find('img').width();

  const distance = buttonWidth - iconWidth / 2;
  $tooltipMarker.css('right', `${distance}px`);
}

// offcanvas language navi in mobile view
function initOffCanvas() {
  const $offCanvasOpener = $('.language-switch-offcanvas-opener');
  const $offCanvasCloser = $('.language-switch-offcanvas-closer');
  const $navigationOffCanvasOpener = $('#quicknavigation-menu');
  const $offCanvasLayer = $('#language-switch-offcanvas');

  $('#language-switch-offcanvas input[data-click-target]').on('change', function (e) {
    window.location.href = $(this).data('click-target');
  });

  $navigationOffCanvasOpener.on('click', (e) => {
    //on open navi-offcanvas close language-switch-offcanvas
    if ($offCanvasLayer.hasClass('slideFromRight')) {
      toogleOffCanvas();
    }
  });

  $offCanvasOpener.on('click', (e) => {
    // close navi-offcanvas if open
    if ($('body').hasClass('panel-offcanvas-active')) {
      $navigationOffCanvasOpener.trigger('click');
    }
    toogleOffCanvas();
  });

  $offCanvasCloser.on('click', (e) => {
    toogleOffCanvas(); /* trigger toggle function because close button is only visible if offcanvas is opened*/
  });
}

function toogleOffCanvas() {
  const $offCanvasLayer = $('#language-switch-offcanvas');
  const $contentWrapper = $('#content-canvas');

  if ($offCanvasLayer.hasClass('slideFromRight')) {
    // hide
    $offCanvasLayer.removeClass('slideFromRight');
    $contentWrapper.removeClass('slideToLeft slideToRight slideFromLeft slideFromRight animation-finished');
    $offCanvasLayer.addClass('slideToRight');
    $contentWrapper.addClass('slideFromLeft');
  } else {
    // show
    $offCanvasLayer.removeClass('slideToRight');
    $contentWrapper.removeClass('slideToLeft slideToRight slideFromLeft slideFromRight animation-finished');
    $offCanvasLayer.addClass('slideFromRight');
    $contentWrapper.addClass('slideToLeft');
  }
}
